/**
 * Menta brand tokens + shared palette for all country/region analyses.
 * Touch this file to retheme the entire report library.
 *
 * Brand anchors:
 *   BLUE #315DF5 — menta primary (logo, CTAs, accents)
 *   Inter — typeface (loaded in index.html)
 */
export const theme = {
  // ── Menta brand ──────────────────────────────────────
  BLUE: '#315DF5',
  BLUE_DARK: '#2348D6',
  BLUE_SOFT: '#4F7AFF',

  // ── Surfaces ─────────────────────────────────────────
  DARK: '#0B1020',       // page background (deeper than before)
  DARK2: '#111936',      // header / elevated surfaces
  CARD: '#1A2142',       // card background
  BORDER: '#243154',     // subtle borders
  BORDER_SOFT: '#1C2647',

  // ── Text ─────────────────────────────────────────────
  TEXT: '#E5E8F2',
  MUTED: '#8B96B8',
  WHITE: '#FFFFFF',

  // ── Difficulty tiers (traffic-light + off-scale) ────
  GREEN: '#22C55E',      // Easy
  YELLOW: '#F59E0B',     // Medium (was ORANGE — softer amber)
  ORANGE: '#F97316',     // legacy alias
  RED: '#EF4444',        // Hard
  BLOCKED: '#6B1C3B',    // Blocked — deep crimson/maroon, stands out on dark bg

  GREY: '#3D4868',       // Not analyzed (darker, less noisy)

  // ── Legacy aliases (kept for existing analyses) ─────
} as const;

export type ThemeColor = keyof typeof theme;

/** Shared font stack — Inter everywhere. */
export const FONT_STACK =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
